import React from "react";
import { Modal } from "components/Modal/Modal";

interface DocumentPreviewModalProps {
  modalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
  previewLocation: string;
}

export const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
  modalVisible,
  setModalVisible,
  previewLocation,
}) => {
  return (
    <Modal
      onClose={() => setModalVisible(false)}
      show={modalVisible}
      width="1/2"
      content={
        <div style={{ height: "85vh" }}>
          <embed
            className="h-full w-full"
            src={previewLocation}
            type="application/pdf"
          />
        </div>
      }
    />
  );
};
